export const EXIT_SNIPPET = 'EXIT_SNIPPET';
export const GO_TO_CFI_PAGE = 'GO_TO_CFI_PAGE';
export const GO_TO_NEXT_PAGE = 'GO_TO_NEXT_PAGE';
export const GO_TO_PREVIOUS_PAGE = 'GO_TO_PREVIOUS_PAGE';
export const GET_NAVIGATION_INFO = 'GET_NAVIGATION_INFO';
